enum ColorClass {
  BackgroundOverlay = "colorBackgroundOverlay",
  Dimmer = "colorDimmer",
  Error = "colorError",
  Green = "colorGreen",
  Ghost = "colorGhost",
  LightBlue = "colorLightBlue",
  LightPink = "colorLightPink",
  LightPurple = "colorLightPurple",
  LightPurpleHover = "colorLightPurpleHover",
  Navy = "colorNavy",
  NavyHover = "colorNavyHover",
  Pink = "colorPink",
  Primary = "colorPrimary",
  Purple = "colorPurple",
  Red = "colorRed",
  RedHover = "colorRedHover",
  Secondary = "colorSecondary",
  Tertiary = "colorTertiary",
  White = "colorWhite",
  Yellow = "colorYellow",
}

export default ColorClass;
